if ($(".in-index").length) {
    $(document).ready(function () {
        /**
         * ==============================
         * CAROUSEL INDICATORS
         * ==============================
         */
        $(".carousel").each(function () {
            const $carousel = $(this);
            const id = $carousel.attr("id");
            if (!id) return;

            if (!$carousel.find(".carousel-indicators").length) {
                $carousel.append("<ol class='carousel-indicators'></ol>");
            }

            const $indicators = $carousel.find(".carousel-indicators");
            $indicators.empty();

            $carousel.find(".carousel-inner > .item").each(function (index) {
                $indicators.append(`
           <li data-target="#${id}"
                        data-slide-to="${index}"
                        class="${index === 0 ? "active" : ""}">
                    </li>
  `);
            });

            const $controls = $carousel.find(".carousel-control");
            if ($controls.length) {
                const $wrapper = $("<div class='arrowWrapper'></div>");
                $controls.appendTo($wrapper);
                $carousel.append($wrapper);
            }
        });
    });
}
